import ChevronIcon from "@icons/chevronIcon.svg";
import SquaresShapeIcon from "@icons/squaresShapeIcon.svg";
import classNames from "classnames";
import styles from "./learningFilterMenu.module.scss";
import { Collapse } from "@kunduz/ui";
import { ILearning } from "@kunduz/data-access-learning-api";
import { useTranslation } from "next-i18next";
import { getContentUrl, ReservedWords } from "@kunduz/utility-common";
import { useState } from "react";
import { FilterMenu } from "./filterMenu";

export const LearningFilterMenu = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";
  const { t } = useTranslation("kunduzcom_learning");
  const [isMobileFilterMenuOpen, setIsMobileFilterMenuOpen] = useState(false);

  const onClickFilterItem = (name: string) => {
    setIsMobileFilterMenuOpen(false);
    props.onItemClicked({ goal: name });
  };

  const renderMenuItems = (
    label: string,
    type: "exams" | "grades" | "courses",
  ) => {
    const renderTriggerNode = (
      <div className={styles["triggerNodeContainer"]}>
        <div>
          <SquaresShapeIcon />
          <span className={styles["label"]}>{label}</span>
        </div>
        <ChevronIcon data-testid={`collapse_trigger_${type}`} />
      </div>
    );

    const renderContentNode = props[type].map((goalType) => {
      const url = getContentUrl({
        lang: props.lang,
        contentType:
          type == "exams"
            ? ReservedWords.TR_CONTENT_EXAM
            : type == "courses"
              ? ReservedWords.TR_CONTENT_COURSE
              : ReservedWords.TR_CONTENT_GRADE,
        segments: [goalType.slug],
      });
      return (
        <LinkComponent
          onClick={() => onClickFilterItem(goalType.name)}
          key={goalType.id}
          className={classNames(
            styles["contentContainer"],
            goalType.slug === props.active && styles["active"],
          )}
          href={url}
          {...(goalType.slug === props.active && { rel: "nofollow" })}
        >
          {goalType.name}
        </LinkComponent>
      );
    });

    return (
      <Collapse
        defaultOpen={true}
        triggerNode={renderTriggerNode}
        contentNode={renderContentNode}
      />
    );
  };

  const renderMenu = () => (
    <>
      {renderMenuItems(t("learning_goal selection_exam_text"), "exams")}
      {renderMenuItems(t("learning_goal_selection_course_text"), "courses")}
      {renderMenuItems(t("learning_goal_selection_grade_text"), "grades")}
    </>
  );

  return (
    <FilterMenu
      hamburgerMenuLabel={t("learning_responsive_hamburger_menu_label")}
      isMobile={props.isMobile}
      isOpen={isMobileFilterMenuOpen}
      setOpen={setIsMobileFilterMenuOpen}
      renderMenu={renderMenu}
    />
  );
};

interface Props {
  active: string;
  exams: ILearning.LearningFilterMenuItem[];
  courses: ILearning.LearningFilterMenuItem[];
  grades: ILearning.LearningFilterMenuItem[];
  isMobile: boolean;
  onItemClicked: (payload: any) => void;
  linkAs?: React.ElementType;
  lang: "tr" | "en";
}
